module.exports = {"440307003":"平湖街道","440307006":"坪地街道","440307007":"坪山街道","440307008":"坑梓街道","440307009":"葵涌街道","440307010":"大鹏街道","440307011":"南澳街道","440307012":"南湾街道","440307013":"坂田街道","440307014":"布吉街道","440307015":"龙城街道","440307016":"龙岗街道","440307017":"横岗街道","440307401":"深圳市大工业区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440307.json
// module id = 1799
// module chunks = 0